import { render, staticRenderFns } from "./CategorySessionPointProgressBar.vue?vue&type=template&id=132d31d8&scoped=true&"
import script from "./CategorySessionPointProgressBar.vue?vue&type=script&lang=js&"
export * from "./CategorySessionPointProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./CategorySessionPointProgressBar.vue?vue&type=style&index=0&id=132d31d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d31d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
